<template>
	<CardGrid tight>
		<Card v-for="offer in offers" :key="`offer-${offer.id}`" :title="offer.title" :subtitle="offer.subtitle">
			<template #badges>
				<Badge v-if="offer.active" :color="Color.Green" active>{{ trans('general.enabled') }}</Badge>
				<Badge v-else :color="Color.Red">{{ trans('general.disabled') }}</Badge>
				<Badge class="cursor-pointer" @click.stop="copyTextToClipboard(offer.id)">#{{ offer.id }}</Badge>
			</template>
			<LabeledObject>
				<template #label>{{ trans('events.bundles.offers.maximum') }}</template>
				<p>{{ trans('events.bundles.offers.available', {number: `${offer.available}/${offer.maximum}`}) }}</p>
			</LabeledObject>
			<template #footer>
				<Link :as="SecondaryButton" :color="Color.Blue" :href="route('events.bundles.offers.edit', [event.id, bundle.id, offer.id])">
					<i class="fa-solid fa-edit mr-2"/>
					{{ trans('general.edit') }}
				</Link>
				<SoftButton :color="Color.Red" @click.stop="remove(offer)">
					<i class="fa-solid fa-trash mr-2"/>
					{{ trans('general.delete') }}
				</SoftButton>
			</template>
		</Card>
		<CreateOffer :event="event" :bundle="bundle"/>
	</CardGrid>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type Bundle} from '@/Types/Events/Bundles/Bundle'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Offer} from '@/Types/Events/Bundles/Offers/Offer'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import CreateOffer from '@/Components/Events/Bundles/Offers/CreateOffer.vue'
import {copyTextToClipboard, showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	bundle:Bundle,
	event:Event,
	offers:Array<Offer>,
}>()

const bundle:Ref<Bundle> = ref(props.bundle)
const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const offers:Ref<Array<Offer>> = ref(props.offers)

function remove(offer:Offer):void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.deleting'))
		axios.delete(route('events.bundles.offers.destroy', {
			event: event.value.id,
			bundle: bundle.value.id,
			offer: offer.id,
		})).then(() => {
			showSuccess(trans('general.deleted'))
			const index = offers.value.findIndex((o:Offer) => o.id === offer.id)
			if(index > -1){
				offers.value.splice(index, 1)
			}
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
